<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qBlxxb/Images/cover.jpg?1685327317428" alt="This image is the cover for the book Pioggia, Le regole del gioco"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pioggia, Le regole del gioco
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Seguito di Le regole del gioco</i></b></p><p>Sono ormai due anni che Brandon Stewart e Dustin Walker stanno insieme, da quella fatidica partita a biliardo che li ha fatti conoscere. Non è stato facile, per Dustin, fare coming out con la propria omofobica famiglia e ammettere i propri sentimenti per Brandon, ma ora i due progettano di sposarsi. Finché il fratello di Dustin, Tristan, non si rifà vivo sperando di riallacciare i rapporti, e Brandon incomincia a chiedersi se non ci sia un modo anche per lui di far pace col proprio fratello. Sono sedici anni che Brandon non vede Russell: sarà bastato un silenzio così lungo a rimarginare le ferite?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L.A. Witt, Martina Nealli
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49c4cb6e